app.service("PatientAiConversationAPI", [
	"$http",
	"ENV",
	"Session",
	function ($http, ENV, Session) {
		const baseUri = ENV.API + "/api/patient-ai-conversation";

		/**
		 * Generates the common headers required for API authentication.
		 * @returns {Object} The headers object.
		 */
		const getHeaders = function () {
			return {
				Authorization: "Bearer " + Session.token,
				"X-PRACTICE-ID": `${Session.practice.id}`,
			};
		};

		var service = {
			isProcessing: false,

			/**
			 * List all the patient's patient AI conversations.
			 * @param {integer} [patientId] - The patient ID.
			 */
			getPatientAiConversationsByPatientId: function (patientId) {
				let config = {
					method: "GET",
					url: `${baseUri}/patient/` + patientId,
					headers: getHeaders(),
				};
				return $http(config);
			},
		};

		return service;
	},
]);